import { INITIAL_LIVE_ORDERS } from './mockLiveDispatchOrders';
import {
  BLENDING_COST_MODEL,
  computeBlendingTotals,
  PENDING_SETTLEMENT_TRIPS,
} from './mockFinancialSettlements';

/** Weekly dispatch volume — Sun 7 Jun through Sat 13 Jun 2026 */
export const WEEKLY_FUEL_DISPATCH_JUNE_2026 = [
  { day: 'Sun', dateLabel: '7 Jun', liters: 124_500 },
  { day: 'Mon', dateLabel: '8 Jun', liters: 98_200 },
  { day: 'Tue', dateLabel: '9 Jun', liters: 145_800 },
  { day: 'Wed', dateLabel: '10 Jun', liters: 132_400 },
  { day: 'Thu', dateLabel: '11 Jun', liters: 168_900 },
  { day: 'Fri', dateLabel: '12 Jun', liters: 156_200 },
  { day: 'Sat', dateLabel: '13 Jun', liters: 189_500 },
];

export const TERMINAL_CAPACITY_PCT = 74;

const BASELINE_ACCUMULATED_LITERS = 428_750;

export function parseOrderVolumeLiters(volumeStr) {
  const match = String(volumeStr).match(/([\d,]+)\s*Liters/i);
  if (!match) return 0;
  return Number(match[1].replace(/,/g, '')) || 0;
}

export function computeAnalyticsMetrics() {
  const orderLiters = INITIAL_LIVE_ORDERS.reduce(
    (sum, order) => sum + parseOrderVolumeLiters(order.volume),
    0,
  );
  const weeklyLiters = WEEKLY_FUEL_DISPATCH_JUNE_2026.reduce((sum, row) => sum + row.liters, 0);
  const totalFleetFreightLiters = BASELINE_ACCUMULATED_LITERS + orderLiters + weeklyLiters;

  const { netMargin } = computeBlendingTotals(BLENDING_COST_MODEL);
  const dispatchedMt = Math.round(totalFleetFreightLiters / 1000);
  const blendingPipelineAed = netMargin * dispatchedMt * 0.15;

  const freightMarginAed = PENDING_SETTLEMENT_TRIPS.reduce((sum, trip) => {
    const saved = trip.calculatedFreightAed - trip.vendorInvoiceAed;
    return sum + Math.max(0, saved);
  }, 0);

  const netProfitPipelineAed = Math.round(blendingPipelineAed + freightMarginAed + 84_200);

  const inTransit = INITIAL_LIVE_ORDERS.filter((o) => o.status === 'Dispatched').length;
  const pendingArrival = INITIAL_LIVE_ORDERS.filter(
    (o) => o.status === 'Unassigned' || o.status === 'Dispatched',
  ).length;

  return {
    totalFleetFreightLiters,
    terminalCapacityPct: TERMINAL_CAPACITY_PCT,
    netProfitPipelineAed,
    alerts: { pendingArrival, inTransit, total: pendingArrival },
  };
}
